import { render, staticRenderFns } from "./OrderForecastDispatchAdd.vue?vue&type=template&id=80e5b558&scoped=true"
import script from "./OrderForecastDispatchAdd.vue?vue&type=script&lang=js"
export * from "./OrderForecastDispatchAdd.vue?vue&type=script&lang=js"
import style0 from "./OrderForecastDispatchAdd.vue?vue&type=style&index=0&id=80e5b558&prod&lang=css"
import style1 from "./OrderForecastDispatchAdd.vue?vue&type=style&index=1&id=80e5b558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e5b558",
  null
  
)

export default component.exports